import * as React from "react";
const SvgIcFullScreen = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 2.5, y: 2.5, width: 11, height: 11, rx: 1.5, stroke: "#A1A7B2" }));
export default SvgIcFullScreen;
